module.exports = __webpack_public_path__ + "media/images/logo-microbius-1-8d83ccef03796fbd88ff5471354f40c3.png";